import { useDispatch } from "react-redux";
import { walletModalShow } from "../../redux/marketplaceSlice";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet,
  WalletConnectButton,
} from "@sei-js/react";

export default function WalletButton() {
  const dispath = useDispatch();

  return (
    <WalletConnectButton buttonClassName="js-wallet w-[140px] h-[40px] text-base border-jacarta-100 hover:bg-accent focus:bg-accent group dark:hover:bg-accent flex  items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15]" />
  );
}
